export default "__VITE_ASSET__BEHDnIzS__"